import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";
import { serializeQueryParam } from '@/utils'

export const getCalendarWeekly = createAsyncThunk('calendar/getCalendar/weekly',
	async ({startDateMeta, venueIdMeta, dayMeta = 0}: CalendarWeeklyQuery) => {
	const url = `v1/calendar-items/weekly${serializeQueryParam({startDate: startDateMeta, venueId: venueIdMeta, day: dayMeta})}`
	const response: AxiosResponse<CalendarWeeklyResponse> = await instance.get(url)
	return response.data
})
